export default __webpack_public_path__ + "static/media/airbnb.14f7e63e.svg";